module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tab":{"overview":"Overview","users":"Project Roles","formAccess":"Form Access","settings":"Settings"}}}')
  delete Component.options._Ctor
}
